import {
  RtbCampaignBasicFormModel,
  RtbCampaignBasicFormModelConstructorParams
} from './RtbCampaignBasicFormModel';
import { AdType, DailyBudgetPlan } from 'core/rtbCampaign/RtbCampaign';
import { AbstractDisplayFormModel } from './DisplayFormModel';

export interface RichMediaFormModel extends RtbCampaignBasicFormModel {
  readonly canEditBudgetPlan: boolean;
  readonly canEditPriceModel: boolean;
}

abstract class AbstractRichMediaFormModel extends AbstractDisplayFormModel {
  override get campaignAdType (): AdType {
    return AdType.RICH_MEDIA;
  }
}

export class EditRichMediaFormModel extends AbstractRichMediaFormModel {
  constructor (...args: RtbCampaignBasicFormModelConstructorParams) {
    super('edit', ...args);
  }
  get canEditBudgetPlan (): boolean {
    return false;
  }
  get canEditPriceModel (): boolean {
    return false;
  }
}

export class CreateRichMediaFormModel extends AbstractRichMediaFormModel {

  constructor (...args: RtbCampaignBasicFormModelConstructorParams) {
    super('create', ...args);
    this.modelDailyBudgetType = DailyBudgetPlan.DAILY;
  }
  get canEditBudgetPlan (): boolean {
    return true;
  }
  get canEditPriceModel (): boolean {
    return true;
  }
}
